import React from 'react';

export const Devices = () => (
    <>
        <rect x='13' y='8' width='8' height='12' rx='1' />
        <path d='M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9' />
        <line x1='16' y1='9' x2='18' y2='9' />
    </>
);